import { CustomLookId } from "..";
import {
  HOME_FREE_COLORS,
  HOME_FREE_PALETTE,
  renderHomeFree,
} from "./homeFree";
import { getCassette, renderHomeFreeCassette } from "./homeFreeCassette";
import { homeFreeTwinklePeak, renderHomeFreeTwinkle } from "./homeFreeTwinkle";
import { renderSyncTest } from "./syncTest";

type Ctx = CanvasRenderingContext2D;

interface CustomLookDefinition {
  /** Draws the look; same arguments as renderLook. */
  render: (ctx: Ctx, w: number, h: number, t: number, seed: number) => void;
  /** Its main colors, for swatches. */
  colors: string[];
  /**
   * When to draw a still (a thumbnail) for `seed`, if not the start; for
   * looks that aren't showing much at the start.
   */
  stillTime?: (seed: number) => number;
  /**
   * For looks with artwork loaded on demand: `load` starts loading it,
   * `loaded` says whether it's in.
   */
  load?: () => void;
  loaded?: () => boolean;
}

/** Each custom look's own renderer (ENG-2291). */
export const CUSTOM_LOOKS: Record<CustomLookId, CustomLookDefinition> = {
  homeFree: {
    render: (ctx, w, h, t, seed) => renderHomeFree(ctx, w, h, t, seed, false),
    colors: HOME_FREE_COLORS,
  },
  homeFreeMulticolor: {
    render: (ctx, w, h, t, seed) => renderHomeFree(ctx, w, h, t, seed, true),
    colors: HOME_FREE_COLORS,
  },
  homeFreeTwinkle: {
    render: renderHomeFreeTwinkle,
    colors: HOME_FREE_COLORS,
    stillTime: homeFreeTwinklePeak,
  },
  homeFreeCassette: {
    render: (ctx, w, h) => renderHomeFreeCassette(ctx, w, h),
    colors: [
      "#000000",
      HOME_FREE_PALETTE.yellow,
      HOME_FREE_PALETTE.salmon,
      HOME_FREE_PALETTE.purple,
    ],
    load: getCassette,
    loaded: () => !!getCassette(),
  },
  syncTest: {
    render: (ctx, w, h, t) => renderSyncTest(ctx, w, h, t),
    colors: ["#000000", "#ffffff"],
    // Mid-second, so the still shows the counter rather than a flash.
    stillTime: () => 0.5,
  },
};
